"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rage_quit_assistant_abi__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "FailedToTransfer",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "CollateralisedClaim",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "Deployed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "differenceSinceLastTime",
                type: "uint256",
            },
        ],
        name: "ETHReceived",
        type: "event",
    },
    {
        inputs: [],
        name: "FEES_AND_MEV_DEPOSIT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "NODE_RUNNER_DEPOSIT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ORIGINAL_DEPOSIT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "SAVETH_POOL_DEPOSIT",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "additionalCollateralisedClaimablePerETH",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "blsPublicKey",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "claimablePerETH",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "collateralisedBalancesAtRageQuit",
        outputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "collateralisedBalancesAtRageQuitLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
        ],
        name: "collateralisedSlotOwnerClaim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "dETHClaim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lp",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "dETHClaimPreview",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dETHConsumedFromAssistantAtTimeOfRageQuit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "dETHDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "dETHRageQuitLP",
        outputs: [
            {
                internalType: "contract RageQuitLP",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dETHRageQuitLPBurntForETH",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dETHRequiredForIsolation",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "dETHWithdrawal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "distributeETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_totalETHSentForBLSKey",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "withdrawalIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "validatorIndex",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "recipient",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                ],
                internalType: "struct WithdrawalStructs.Sweep[]",
                name: "_unreportedSweeps",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        components: [
                            {
                                internalType: "uint256",
                                name: "withdrawalIndex",
                                type: "uint256",
                            },
                            {
                                internalType: "uint256",
                                name: "validatorIndex",
                                type: "uint256",
                            },
                            {
                                internalType: "address",
                                name: "recipient",
                                type: "address",
                            },
                            {
                                internalType: "uint256",
                                name: "amount",
                                type: "uint256",
                            },
                        ],
                        internalType: "struct WithdrawalStructs.Sweep",
                        name: "sweep",
                        type: "tuple",
                    },
                    {
                        internalType: "uint256",
                        name: "slot",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "block",
                        type: "uint256",
                    },
                ],
                internalType: "struct WithdrawalStructs.SweepWithSlotInfo",
                name: "_finalSweep",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "bytes",
                        name: "blsPublicKey",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "withdrawalCredentials",
                        type: "bytes",
                    },
                    {
                        internalType: "bool",
                        name: "slashed",
                        type: "bool",
                    },
                    {
                        internalType: "uint64",
                        name: "activeBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "effectiveBalance",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "exitEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "activationEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "withdrawalEpoch",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "currentCheckpointEpoch",
                        type: "uint64",
                    },
                ],
                internalType: "struct IDataStructures.ETH2DataReport",
                name: "_beaconChainReport",
                type: "tuple",
            },
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "deadline",
                        type: "uint256",
                    },
                    {
                        internalType: "uint8",
                        name: "v",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32",
                    },
                ],
                internalType: "struct WithdrawalStructs.VerifierSignature",
                name: "_signature",
                type: "tuple",
            },
        ],
        name: "executeFullWithdrawal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getCollateralisedSlotClaimableAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "claimable",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "totalErrosionOfPrincipleBalance",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getFreeFloatingSlotClaimableAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "claimable",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "differenceVersusMaxClaimable",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getFullWithdrawalsAdaptor",
        outputs: [
            {
                internalType: "contract IFullWithdrawals",
                name: "withdrawals",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getLSDNFactory",
        outputs: [
            {
                internalType: "address",
                name: "factory",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getRageQuitAssistantDeployer",
        outputs: [
            {
                internalType: "contract RageQuitAssistantDeployer",
                name: "deployer",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getRageQuitLPDeployer",
        outputs: [
            {
                internalType: "contract RageQuitLPDeployer",
                name: "deployer",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getSweepReportingAdaptor",
        outputs: [
            {
                internalType: "contract ISweepReporter",
                name: "reporter",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "inflationClaimablePerETH",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_feesAndMevPool",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_blsPublicKey",
                type: "bytes",
            },
        ],
        name: "init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "isFullWithdrawalExecuted",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isNodeOperatorFundedByZec",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastSeenETH",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "liquidStakingNetworkManager",
        outputs: [
            {
                internalType: "contract LiquidStakingManager",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lsdnFactory",
        outputs: [
            {
                internalType: "contract ILSDNFactory",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nodeOperatorClaim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_operator",
                type: "address",
            },
        ],
        name: "nodeOperatorClaimPreview",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nodeOperatorClaimed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "prepareRageQuit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "previewDistributeETH",
        outputs: [
            {
                internalType: "uint256",
                name: "totalETHReceived",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "additionalETHSinceLastCall",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "additionalClaimableAmountPerETHOfPrincipleDeposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "totalTopUps",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "totalUnknownTopUps",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "inflation",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "processedTopUps",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "registeredNodeRunner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "sETHClaim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_lp",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "sETHClaimPreview",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "sETHDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "sETHRageQuitLP",
        outputs: [
            {
                internalType: "contract RageQuitLP",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "sETHTokenForLSDHouse",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "sETHWithdrawal",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "savETHIndexIdOwnedBySmartWalletRageQuitting",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "smartWalletOfKnot",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalClaimed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalDETHDeposited",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalETHReceivedFromRageQuit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSETHDeposited",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
class Rage_quit_assistant_abi__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Rage_quit_assistant_abi__factory = Rage_quit_assistant_abi__factory;
Rage_quit_assistant_abi__factory.abi = _abi;
